<script lang="ts">
    import type {MediaViewerFile} from 'src/features/media-viewer/lib/mv-types';
    import {fly} from 'svelte/transition';
    import KpLoadingBlock from 'shared/components/kp-loading/KpLoadingBlock.svelte';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';
    import MvSpreadsheetViewer from '../mv-spreadsheet-viewer/MvSpreadsheetViewer.svelte';

    export let file: MediaViewerFile;

    const flyInAnimParams = {y: 20, duration: 250};

    let initialLoad = true;
    let loadError = false;

    const handleLoadStart = () => {
        initialLoad = false;
    };

    const handleLoadError = () => {
        loadError = true;
        initialLoad = false;
    };
</script>

<div class="mv-spreadsheet-file">
    <MvSpreadsheetViewer {file}
                         on:load-start={handleLoadStart}
                         on:load-error={handleLoadError}/>
</div>

{#if initialLoad}
    <div class="loading-container">
        <KpLoadingBlock size="sm"/>
    </div>
{/if}

{#if loadError}
    <div class="loading-container load-error-container" in:fly={flyInAnimParams}>
        <IconedContent icon="exclamation"
                       orientation="vertical"
                       align="center"
                       justify="center"
                       iconColor="var(--danger-red)">

            Nastala chyba při načítání souboru
        </IconedContent>
    </div>
{/if}

<style lang="less">
    @import (reference) "src/features/media-viewer/media-viewer.themes.less";
    @import (reference) "styles/portaro-erp.less";

    .mv-spreadsheet-file {
        .flex-grow();
        width: 100%;
        height: 100%;
        position: relative;
        overflow: auto;
    }

    .loading-container {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .load-error-container {
        color: var(--danger-red);
    }
</style>
